import { ListItem } from './Item';
import { ListRoot } from './Root';

export const List = {
  Root: ListRoot,
  Item: ListItem,
};
